"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFilter = void 0;
const react_1 = require("react");
const useSpectrum_1 = __importDefault(require("./useSpectrum"));
const emptyData = { filters: {} };
function useFilter(filterID) {
    const { filters } = (0, useSpectrum_1.default)(emptyData);
    return (0, react_1.useMemo)(() => filters.find((filter) => filter.name === filterID) || null, [filterID, filters]);
}
exports.useFilter = useFilter;
